<template>
	<div class="col-12 mt-4">
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<div class="valid_button">
			<button type="submit"
				class="btn btn-valid"
				@click.prevent="sendDatas">{{ $t("Button.validate") }}</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidStepVideo",
	components: {lottie_error, throbber},
	props: {
		value: "",
		id: {
			type: Number,
			required: true,
		},
		videoArray: {
			type: Array,
			required: false,
		},
		outroId: Number,
	},
	data() {
		return {
			text_error: "",
			check: false,
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			if (this.outroId === undefined) {
				this.text_error = "Vous devez sélectionner une vidéo pour votre étape. Veuillez recommencer svp.";
				this.$refs.modalError.show();
			}
			else {
				this.$refs.loaderModal.show();
				let bodyFormData = new FormData();
				bodyFormData.append("_method", "put");
				bodyFormData.append("outroId", this.outroId);
				axios.post(BASE_URL + "/public/api/stepVideos/" + $this.id,
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).then(function () {
					$this.$refs.loaderModal.hide();
					EventBus.$emit("setStepVideoComplete", $this.id);
				}).catch(error => {
					$this.text_error = this.$root.$t("Errors.message_project") + error;
					$this.$refs.modalError.show();
				});
			}
		},
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
</style>
